import React from 'react';
import '../../App.css';
import CardGrid from "../CardGrid.js";

export default function Home() {
  return (
    <div className="home">
      <CardGrid />

      <div
        style={{
          position: "fixed",
          bottom: "60px",
          right: "20px",
          color: "white",
          height: "40px",
          width: "300px",
          backgroundColor: "black",
          textAlign: "center",
          opacity: "0.9",
          borderRadius: "5px",
          border: "2px ridge white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <span style={{ fontSize: "14px" }}>
          Powered By{" "}
          <a
            href="https://techiteasy.co.in/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#00d4ff", textDecoration: "none", fontWeight: "bold" }}
          >
            Tech It Easy
          </a>
        </span>
      </div>
    </div>
  );
}
